import React, { useEffect, useState } from "react";

import TransactionTicket from "pages/_components/TransactionTicket";
import NewDirectDebitSummaryData from "pages/v2/directDebit/NewDirectDebitSummaryData";
import { actions as directDebitActions, selectors as directDebitSelectors } from "reducers/directDebit";
import { push, goBack, go } from "react-router-redux";
import { actions as formActions } from "reducers/form";
import { func, shape, bool, arrayOf } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { resizableRoute } from "pages/_components/Resizable";
import * as i18n from "util/i18n";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import * as configUtils from "util/config";
import { selectors as sessionSelectors } from "reducers/session";
import * as accountUtils from "util/accounts";
import moment from "moment";
import { parseToAmountFormat } from "util/number";

const NewDirectDebitTransaction = (props) => {
    const {
        transactionData,
        isDesktop,
        fetching,
        isSmallDesktop,
        dispatch,
        isGoBackDirectDebit,
        history,
        accounts,
        loggedUser,
        embeddedInV3Shell,
    } = props;
    const [fetchingDownload, setFetchingDownload] = useState(false);
    const [accountName, setAccountName] = useState("");

    const summaryDataComponent = () => <NewDirectDebitSummaryData />;

    const signTransaction = () => {
        const signTransactionData = summaryDataComponent();

        dispatch(push("/transactions/sign"));
        dispatch(
            formActions.signTransactionData({
                idTransaction: transactionData?.idTransaction,
                idActivity: transactionData?.idActivity,
                idForm: "",
                content: signTransactionData,
                title: `directDebit.success.title`,
                pendingDispatch: transactionData?.pendingDispatch,
            }),
        );

        dispatch(
            formActions.signTransactionPreview({
                idActivity: transactionData?.idActivity,
                idTransaction: transactionData?.idTransaction,
                idForm: "",
                ticketData: transactionData,
            }),
        );
    };

    const buttonsDetail = () => [
        {
            label: "directDebit.button.goToList",
            bsStyle: "primary",
            onClick: () => dispatch(push("/v2/directDebit/list")),
        },
    ];
    const haveTransactionPage = (path) => {
        const pattern1 = /.*\/transaction\/[A-Za-z0-9]*/;
        return pattern1.test(path);
    };
    const getSendDateFormat = (date) => {
        const hours = configUtils.get("time.limit.directDebitRequest.extract", "12");
        const tempDate = date && hours ? moment(date).set({ hour: hours, minute: "00", second: "00" }) : moment(date);
        const processDate = moment(date).isAfter(tempDate) ? tempDate.add(1, "days") : tempDate;
        return processDate.format("DD/MM/YYYY HH:mm");
    };

    const fixPath = async () => {
        const unlisten = await history?.listen((location) => {
            const nextPath = location?.pathname;
            if (haveTransactionPage(nextPath)) {
                dispatch(goBack());
            }
            if (nextPath === "/transactions/cancel") {
                dispatch(go(-2));
            }
            unlisten();
        });
    };

    const handleBack = () => {
        if (isGoBackDirectDebit) {
            dispatch(push("/v2/directDebit/list"));
        } else {
            fixPath();
            dispatch(goBack());
        }
    };
    useEffect(() => {
        if (accounts.length === 0) {
            dispatch(accountsActions.listAccounts(loggedUser?.userId));
        }

        if (!transactionData?.idTransaction) {
            dispatch(goBack());
        }

        return () => {
            dispatch(directDebitActions.setGoBackDirectDebit(false));
        };
    }, []);
    useEffect(() => {
        if (transactionData?.data && accounts.length > 0) {
            const account = accounts.find((acc) => acc.cbu === transactionData.data.creditAccount);
            if (account) {
                setAccountName(accountUtils.getAccountName(account));
            }
        }
    }, [transactionData, accounts]);

    const creatorFullName =
        transactionData?.creatorFullName ||
        `${transactionData?.userCreatorLastName}, ${transactionData?.userCreatorFirstName}`;

    const centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 style={{ width: "100%", marginTop: "2px" }}>{i18n.get(`directDebit.success.title`)}</h1>
        </div>
    );

    const exportPdf = async () => {
        setFetchingDownload(true);
        const FORM_SUMMARY = "directDebit.create.table.header";
        const bodyData = [
            getGeneralTicketItem(`${FORM_SUMMARY}.dateCreate`, transactionData.modificationDateTime, "datetime"),
            getGeneralTicketItem(
                `${FORM_SUMMARY}.voucher`,
                transactionData?.idTransaction?.substring(0, 8)?.toUpperCase() || "",
                "string",
            ),
        ];

        bodyData.push(
            getGeneralTicketItem(`${FORM_SUMMARY}.creditAccount`, accountName, "string"),
            getGeneralTicketItem(`${FORM_SUMMARY}.fileReference`, transactionData?.data?.reference || "", "string"),
            getGeneralTicketItem(
                `${FORM_SUMMARY}.payroll`,
                transactionData?.data?.payrollsNumber?.label || "",
                "string",
            ),
            getGeneralTicketItem(`${FORM_SUMMARY}.dateUpload`, transactionData?.creationDateTime, "datetime"),
            getGeneralTicketItem(
                `${FORM_SUMMARY}.fileName`,
                transactionData?.data?.file?.newFileName?.split(".")[0] || "",
                "string",
            ),
            getGeneralTicketItem(
                `${FORM_SUMMARY}.chargesOrdersCount`,
                transactionData.data.file.validLines || "",
                "string",
            ),
            getGeneralTicketItem(
                `${FORM_SUMMARY}.totalAmount`,
                `${transactionData?.data?.file?.totalAmount?.currency} ${parseToAmountFormat(
                    transactionData?.data?.file?.totalAmount?.bigQuantity,
                )}`,
                "string",
            ),
            getGeneralTicketItem(
                `${FORM_SUMMARY}.sendDate`,
                getSendDateFormat(transactionData?.creationDateTime),
                "string",
            ),
        );

        const ticketData = {
            ticketName: i18n.get("directDebit.success.title"),
            ticketBody: bodyData,
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18n.get("global.download.success"));

        setFetchingDownload(false);
    };

    const isFinished = transactionData?.idTransactionStatus === "FINISHED";

    return (
        <>
            {transactionData?.idTransaction && (
                <TransactionTicket
                    notificationScope="directDebit"
                    embeddedInV3Shell={embeddedInV3Shell}
                    embeddedV3GoBackPath="/v2/directDebit/list"
                    embeddedV3LayoutScopes={["directDebit"]}
                    handleBack={handleBack}
                    handleClick={exportPdf}
                    uniqueDownload={isFinished}
                    downloadImageWhite={!isDesktop}
                    rightContent={transactionData?.idTransactionStatus === "PENDING" && null}
                    emptyRightOption={
                        (isDesktop && transactionData?.idTransactionStatus !== "FINISHED") ||
                        (!isDesktop &&
                            transactionData?.idTransactionStatus !== "PENDING" &&
                            transactionData?.idTransactionStatus !== "FINISHED")
                    }
                    headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                    hasInlineButtons
                    hideMobileMenu={!isDesktop}
                    fetching={fetching}
                    summary={{
                        ...transactionData,
                        cancelledUser: transactionData?.data?.cancelledUser,
                        cancelledTime: transactionData?.data?.cancelledTime,
                        creatorFullName,
                    }}
                    centerElement={isDesktop ? undefined : centerContentMobile}
                    buttonsDetail={buttonsDetail()}
                    isDesktop={isDesktop}
                    isSmallDesktop={isSmallDesktop}
                    onSignTicket={signTransaction}
                    ignoreHomeButton
                    summaryTitle="directDebit.success.title"
                    isFetchingExport={fetchingDownload || !accountName}>
                    <NewDirectDebitSummaryData isDesktop={isDesktop} />
                </TransactionTicket>
            )}
        </>
    );
};

NewDirectDebitTransaction.propTypes = {
    transactionData: shape({}).isRequired,
    fetching: bool.isRequired,
    isDesktop: bool.isRequired,
    isSmallDesktop: bool.isRequired,
    dispatch: func.isRequired,
    isGoBackDirectDebit: bool.isRequired,
    history: shape({
        listen: func.isRequired,
    }).isRequired,
    accounts: arrayOf(shape({})).isRequired,
    loggedUser: shape({}).isRequired,
    embeddedInV3Shell: bool,
};
NewDirectDebitTransaction.defaultProps = {
    embeddedInV3Shell: false,
};

const mapStateToProps = (state) => ({
    transactionData: directDebitSelectors.getDirectDebitTransactionData(state),
    isGoBackDirectDebit: directDebitSelectors.isGoBackDirectDebit(state),
    accounts: accountsSelectors.getAccounts(state),
    loggedUser: sessionSelectors.getUser(state),
    fetching: false,
});

export default compose(connect(mapStateToProps), resizableRoute)(NewDirectDebitTransaction);
